import { useContext } from 'react';
import { WebAppContext, AppContextType } from '../context/app-context';

/**
 * Custom hook to access the application context.
 * @returns {Object} An object containing various context values and functions.
 */
const useAppContext = () => {
  const data = useContext(WebAppContext) as AppContextType;
  return { ...data };
};

export default useAppContext;
